import {
    MORNING_BRIEFING_START_HOUR,
    MORNING_BRIEFING_END_HOUR,
    EVENING_BRIEFING_START_HOUR,
    EVENING_BRIEFING_END_HOUR,
    FORCE_MORNING_BRIEFING_START_HOUR,
    FORCE_MORNING_BRIEFING_END_HOUR,
    FORCE_EVENING_BRIEFING_START_HOUR,
    FORCE_EVENING_BRIEFING_END_HOUR,
} from './constants';
import { userDate, getHours, getMinutes, getSeconds } from 'owa-datetime';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Checks if current time is within the morning briefing window.
 * @returns true if current hour is between the morning briefing hours
 */
export function isMorningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);

    if (isGlobalFeatureEnabled('mon-copilot-inbox-briefings-agent')) {
        return hour >= FORCE_MORNING_BRIEFING_START_HOUR && hour < FORCE_MORNING_BRIEFING_END_HOUR;
    }
    return hour >= MORNING_BRIEFING_START_HOUR && hour < MORNING_BRIEFING_END_HOUR;
}

/**
 * Checks if current time is within the evening briefing window
 * @returns true if current hour is between the evening briefing hours
 */
export function isEveningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);
    if (isGlobalFeatureEnabled('mon-copilot-inbox-briefings-agent')) {
        return hour >= FORCE_EVENING_BRIEFING_START_HOUR && hour < FORCE_EVENING_BRIEFING_END_HOUR;
    }

    return hour >= EVENING_BRIEFING_START_HOUR && hour < EVENING_BRIEFING_END_HOUR;
}

/**
 * Returns the number of milliseconds until the active briefing window ends,
 * or 0 if no briefing window is currently active.
 */
export function getMsUntilBriefingWindowEnds(): number {
    const now = userDate();
    const hour = getHours(now);

    let endHour: number | undefined;
    if (hour >= MORNING_BRIEFING_START_HOUR && hour < MORNING_BRIEFING_END_HOUR) {
        endHour = MORNING_BRIEFING_END_HOUR;
    } else if (hour >= EVENING_BRIEFING_START_HOUR && hour < EVENING_BRIEFING_END_HOUR) {
        endHour = EVENING_BRIEFING_END_HOUR;
    }

    if (endHour === undefined) {
        return 0;
    }

    const minutesLeft = (endHour - hour - 1) * 60 + (60 - getMinutes(now));
    const secondsLeft = minutesLeft * 60 - getSeconds(now);

    // Add an extra minute in case the nudge is rendered right before the window expires,
    // to ensure the nudge doesn't disappear before the user has a chance to see it and interact with it.
    return (secondsLeft + 60) * 1000;
}
